import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Checkbox,
  FormControlLabel,
  IconButton,
  Typography,
  Box,
  Tabs,
  Tab,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from '@mui/material/styles';
import { CheckboxProps } from '@mui/material/Checkbox';


interface ManageNotificationProps {
  open: boolean;
  onClose: () => void;
}

const ManageNotification: React.FC<ManageNotificationProps> = ({ open, onClose }) => {
  const [activeTab, setActiveTab] = useState(0);


  const BpIcon = styled('span')(({ theme }) => ({
    borderRadius: 4,
    width: 24,
    height: 24,
    boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
    backgroundColor: '#fff',

    'input:hover ~ &': {
      border: '1px solid #666666',
    },

  }));

  const BpCheckedIcon = styled(BpIcon)({
    '&::before': {
      display: 'block',
      width: 24,
      height: 24,
      backgroundImage:
        "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
        " fillRule='evenodd' clipRule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
        "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
      content: '""',
    },
    'input ~ &': {
      backgroundColor: '#614EFA',
      border: 'none',
    },

    'input:hover ~ &': {
      border: 'none',
    }
  });


  function BpCheckbox(props: CheckboxProps) {
    return (
      <Checkbox
        sx={{ '&:hover': { bgcolor: 'transparent' } }}
        disableRipple
        color="default"
        checkedIcon={<BpCheckedIcon />}
        icon={<BpIcon />}
        {...props}


      />
    );
  }

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };


  return (
    <Dialog open={open} onClose={onClose} fullWidth sx={{
      "& .MuiDialog-paper": {
        maxWidth: "506px",
        borderRadius: "16px",
        position: "relative",
      },
    }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "20px",
        }}
      >
        <Typography
          sx={{
            fontSize: {
              xs: "22px",
              md: "24px",
            },
            fontWeight: "500",
            color: "#333333",
          }}
        >
          Plan Usage Notification
        </Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            color: "#666",
            position: "absolute",
            top: "12px",
            right: "16px",
            "&:hover": {
              color: "#000",
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>

      {/* Tabs */}
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          sx={{
            width: { xs: '100%', lg: 'fit-content' }
          }}
        >
          <Tab label="All" sx={{ textTransform: 'capitalize' }} />
          <Tab label="Easywebinar" sx={{ textTransform: 'capitalize', fontSize: '14px', fontWeight: '500' }} />
          <Tab label="EasyCRM" sx={{ textTransform: 'capitalize', fontSize: '14px', fontWeight: '500' }} />
        </Tabs>
      </Box>

      {/* Tab Panels */}
      <DialogContent sx={{ padding: "32px 20px" }}>
        {activeTab === 0 && (
          <Box>
            <Typography
              sx={{ marginBottom: "30px", fontSize: "16px", color: "#333333" }}
            >
              Select your preferred usage notification alerts to stay updated.
            </Typography>
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
              {["Notify at 80%", "Notify at 90%", "Notify at 100%"].map((label, index) => (
                <Box key={index} sx={{
                  flex: {
                    xs: "1 1 100%",
                    sm: "1 1 calc(50% - 16px)"
                  }
                }}>
                  <FormControlLabel
                    sx={{
                      fontSize: "14px",
                      color: "#333333",
                    }}
                    control={
                      <BpCheckbox sx={{
                        '& + span': {
                          ml: '3px'
                        }
                      }} />
                    }
                    label={label}
                  />
                </Box>
              ))}
            </Box>
          </Box>
        )}
        {activeTab === 1 && (
          <Box>
            <Typography
              sx={{ marginBottom: "30px", fontSize: "16px", color: "#333333" }}
            >
              Select your preferred usage notification alerts to stay updated.
            </Typography>
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
              {["Notify at 80%", "Notify at 90%", "Notify at 100%"].map((label, index) => (
                <Box key={index} sx={{
                  flex: {
                    xs: "1 1 100%",
                    sm: "1 1 calc(50% - 16px)"
                  }
                }}>
                  <FormControlLabel
                    sx={{
                      fontSize: "14px",
                      color: "#333333",
                    }}
                    control={
                      <BpCheckbox sx={{
                        '& + span': {
                          ml: '3px'
                        }
                      }} />
                    }
                    label={label}
                  />
                </Box>
              ))}
            </Box>
          </Box>
        )}
        {activeTab === 2 && (
          <Box>
            <Typography
              sx={{ marginBottom: "30px", fontSize: "16px", color: "#333333" }}
            >
              Select your preferred usage notification alerts to stay updated.
            </Typography>
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
              {["Notify at 80%", "Notify at 90%", "Notify at 100%"].map((label, index) => (
                <Box key={index} sx={{
                  flex: {
                    xs: "1 1 100%",
                    sm: "1 1 calc(50% - 16px)"
                  }
                }}>
                  <FormControlLabel
                    sx={{
                      fontSize: "14px",
                      color: "#333333",
                    }}
                    control={
                      <BpCheckbox sx={{
                        '& + span': {
                          ml: '3px'
                        }
                      }} />
                    }
                    label={label}
                  />
                </Box>
              ))}
            </Box>
          </Box>
        )}

      </DialogContent>

      {/* Dialog Actions */}
      <DialogActions
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          padding: "20px",
        }}
      >
        <Button
          variant="outlined"
          color="primary"
          onClick={onClose}
          sx={{
            textTransform: "capitalize",
            padding: "8px 29px",
            borderRadius: "8px",
            border: "1px solid #E8EAF0",
            color: "#2B2B30",
            mr: "16px",
          }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={onClose}
          sx={{
            textTransform: "capitalize",
            padding: "8px 29px",
            borderRadius: "8px",
          }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default ManageNotification;
